






















import Vue from 'vue';
import {UserViewModel} from "@/models/UserViewModel";
import AmendmentListPanelMetrovan from "@/components/amendments/AmendmentListPanelMetrovan.vue";
import AmendmentListPanelMunicipal from "@/components/amendments/AmendmentListPanelMunicipal.vue";

export default Vue.extend( {
  name: "AmendmentList",
  components: {
    AmendmentListPanelMunicipal,
    AmendmentListPanelMetrovan ,
  },
  data():{

  } {
    return { }
  },
  computed: {
    loggedInUser(): UserViewModel {
      return this.$store.state.loggedInUser;
    },
  } ,
  methods: {  },
  mounted: async function() {
    // do something
  },
  beforeCreate() {
    setTimeout( async () => {
      if ( this.$store.state.loggedInUser == null ) {
        //make one attempt to get the current user info
        try {
          let result = await this.axios.get('Users/GetUserFromToken');
          if ( result.status === 200 ) {
            await this.$store.dispatch('updateUser', result.data);
          }
        } catch ( err ) {
          if ( err.response.status === 400  ) {
            await this.$router.push('/Login');
          }
        }
      }
    } , 250 );
  },
} )

